import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Building2, TrendingUp, ArrowUpRight } from "lucide-react";
import { gbp, pct } from "../lib/format";
import { Button } from "./ui/button";

export const PropertyCard = ({ property }) => {
  const navigate = useNavigate();
  const handleView = () => navigate(`/property/${property.id}`);
  return (
    <article
      className="card-lift group flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white"
      data-testid={`property-card-${property.id}`}
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-slate-100">
        <img
          src={property.image_url}
          alt={property.name}
          className="image-zoom h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute left-4 top-4 flex items-center gap-2 rounded-sm bg-white/95 px-2.5 py-1 text-xs font-semibold uppercase tracking-widest text-slate-800 shadow-sm">
          <Building2 className="h-3 w-3 brickstok-gold" /> {property.asset_type}
        </div>
        <div className="absolute right-4 top-4 rounded-sm bg-slate-900 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-white">
          {property.city}
        </div>
      </div>

      <div className="flex flex-1 flex-col p-6">
        <div className="overline">Asset</div>
        <h3 className="mt-1 font-display text-2xl font-semibold text-slate-900" data-testid={`property-name-${property.id}`}>
          {property.name}
        </h3>
        <div className="mt-2 flex items-center gap-1.5 text-sm text-slate-500">
          <MapPin className="h-3.5 w-3.5" /> {property.address}
        </div>

        <p className="mt-4 line-clamp-2 text-sm leading-relaxed text-slate-600">{property.description}</p>

        <div className="mt-6 grid grid-cols-3 gap-4 border-t border-slate-100 pt-5">
          <div>
            <div className="overline">Valuation</div>
            <div className="mt-1 font-display text-lg font-semibold text-slate-900 font-mono-num" data-testid={`property-valuation-${property.id}`}>
              {gbp(property.valuation_gbp, { compact: true })}
            </div>
          </div>
          <div>
            <div className="overline">Min Ticket</div>
            <div className="mt-1 font-display text-lg font-semibold text-slate-900 font-mono-num">
              {gbp(property.min_investment_gbp)}
            </div>
          </div>
          <div>
            <div className="overline">Net Yield</div>
            <div className="mt-1 flex items-center gap-1 font-display text-lg font-semibold font-mono-num" style={{ color: "#D4AF37" }} data-testid={`property-yield-${property.id}`}>
              <TrendingUp className="h-4 w-4" /> {pct(property.projected_yield_pct)}
            </div>
          </div>
        </div>

        <div className="mt-6 flex items-center gap-3">
          <Button
            onClick={handleView}
            className="flex-1 bg-slate-900 text-white hover:bg-slate-800"
            data-testid={`view-investment-btn-${property.id}`}
          >
            View Investment <ArrowUpRight className="ml-1.5 h-4 w-4" />
          </Button>
          <div className="text-xs text-slate-500">
            <div className="overline">Tenant</div>
            <div className="mt-0.5 max-w-[9rem] truncate">{property.tenant}</div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default PropertyCard;
